<template>
    <div class="ke-home-page">
        <!-- 首页内容 -->
        <div class="home">
            <!-- 轮播图 -->
            <div class="carousel">
                <div class="carousel-container">
                    <div class="carousel-slider" :style="{ transform: `translateX(-${currentSlide * 100}%)` }">
                        <div v-for="(slide, index) in carouselSlides" :key="index" class="carousel-slide">
                            <a :href="slide.link" class="carousel-wrap">
                                <div class="carousel-image-wrapper hover-scale">
                                    <img v-lazy="slide.image" :alt="slide.title" class="img">
                                    <div class="img-mask"></div>
                                </div>
                                <div class="text-wrap">
                                    <div class="title">{{ slide.title }}</div>
                                    <div class="more-btn">
                                        <span>查看更多</span>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>

                    <!-- 轮播图指示器 -->
                    <ul class="carousel-dots">
                        <li v-for="(slide, index) in carouselSlides" :key="index"
                            :class="{ active: currentSlide === index }" @click="goToSlide(index)">
                            <button></button>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- 导航卡片 -->
            <div class="nav">
                <div class="wrap">
                    <div class="btns">
                        <div v-for="(nav, index) in navCards" :key="index" class="item hover-zoom"
                            @click="goPage(nav.link)">
                            <!--  :href="nav.link"  -->
                            <div class="title">{{ nav.title }}</div>
                            <div class="nav-image">
                                <img :src="nav.image" :alt="nav.title">
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 核心业务 -->
            <div class="business">
                <div class="wrap">
                    <div class="text">
                        <div class="title">
                            <h3>核心业务</h3>
                            <h4>{{ businessTypes[selectedBusiness].name }}</h4>
                        </div>
                        <div class="desc">{{ businessTypes[selectedBusiness].description }}</div>
                    </div>
                    <div class="pic">
                        <div v-for="(business, index) in businessTypes" :key="index"
                            :class="['item', { select: selectedBusiness === index }]" @click="selectBusiness(index)"
                            class="business-item">
                            <h3>{{ business.name }}</h3>
                            <div class="business-image">
                                <img :src="business.icon" :alt="business.name">
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 服务者发展 -->
            <div class="dev">
                <div class="wrap">
                    <div class="title">服务者发展</div>
                    <div class="contain">
                        <div class="img" :style="{ backgroundImage: `url(${selectedService.image})` }">
                            {{ selectedService.name }}
                        </div>

                        <div class="list">
                            <div v-for="(service, index) in services" :key="index"
                                :class="['item', { select: selectedServiceIndex === index }]"
                                @mouseover="selectService(index)" class="service-item hover-rotate">
                                <div :class="['name', { select: selectedServiceIndex === index }]">{{ service.name }}</div>
                                <div :class="['desc', { select: selectedServiceIndex === index }]">{{ service.description }}
                                </div>
                                <div :class="['icon', { select: selectedServiceIndex === index }]"
                                    :style="{ backgroundImage: `url(${service.icon})` }"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import Vue from 'vue'
// import VueLazyload from 'vue-lazyload'

// // 配置图片懒加载
// Vue.use(VueLazyload, {
//     preLoad: 1.3,
//     attempt: 1
// })

export default {
    name: 'KeHomePage',
    data() {
        return {
            isMobileMenuOpen: false,
            currentSlide: 0,
            selectedBusiness: 0,
            selectedServiceIndex: 0,

            // 轮播图数据
            carouselSlides: [
                {
                    title: '',
                    image: require('@/assets/imgs/aboutUs/about.png'),
                    link: ''
                },
            ],
            // 导航卡片数据
            navCards: [
                {
                    title: '公司简介',
                    image: require('@/assets/imgs/aboutUs/navCards_gsjj.png'),
                    link: '/aboutUs/aboutUs_details/0'
                },
                {
                    title: '愿景与使命',
                    image: require('@/assets/imgs/aboutUs/navCards_yjysm.png'),
                    link: '/aboutUs/aboutUs_details/1'
                },
                {
                    title: '发展历程',
                    image: require('@/assets/imgs/aboutUs/navCards_fzlc.png'),
                    link: '/aboutUs/aboutUs_details/2'
                }
            ],

            // 核心业务数据
            businessTypes: [
                {
                    name: '二手房',
                    description: '名盛房产已连接200多个品牌，数十万服务者，二手房业务覆盖全国近百个城市，可以为买卖双方提供从咨询、委托、带看、签前、签后的全流程服务。',
                    icon: require('@/assets/imgs/aboutUs/business_1_1.png'),
                },
                {
                    name: '新房',
                    description: '名盛房产新房已经覆盖全国超300个城市，合作全国百强开发商，线上提供海量新房楼盘数据，线下连接数十万专业经纪人，为消费者提供安心的品质购房体验。',
                    icon: require('@/assets/imgs/aboutUs/business_1_2.png'),
                },
                {
                    name: '租房',
                    description: '名盛房产致力于提升包含城市新市民、青年人等各类人群的租住体验。名盛房产推出涵盖7大服务承诺的微光服务保障体系，覆盖从租房、找房、出租及租后全程，让租房成为一种美好生活方式。',
                    icon: require('@/assets/imgs/aboutUs/business_2_1.png'),
                },
                {
                    name: '整装大家居',
                    description: '整装大家居致力于为消费者提供"家的整体解决方案"，通过个性化设计方案、多样化产品组合、标准化履约交付，通过整装、定制、软装、家电及局部翻新五大服务，满足家装前中后的所有需求，致力于为3亿家庭打造品质居住服务，让"家的美好，一站实现"。',
                    icon: require('@/assets/imgs/aboutUs/business_2_2.png'),
                }
            ],

            // 服务者发展数据
            services: [
                {
                    name: '名盛经纪学堂',
                    description: '赋能精英，赢在未来。本线上学堂是我司倾力打造的 “全员成长加速器” 与 “专业能力中央厨房”。课程涉及租赁、新房、二手房、房产自媒体等多个业务板块，旨在通过系统化、数字化、场景化的学习平台，打破时空限制，为每一位经纪人提供持续、即时、高效的职业赋能，构筑公司最坚实的人才护城河与核心竞争力',
                    image: require('@/assets/imgs/aboutUs/services_jj.jpg'),
                    icon: 'https://s1.ljcdn.com/parma/client/media/src/client/pages/about/home/imgs/dev_icon_01.fa3468e3.png'
                },
                {
                    name: '名盛青蓝学堂',
                    description: '从精英到领袖的锻造炉。本学堂是为核心业务骨干量身定制的 “店长预备役孵化计划”。旨在通过系统化的管理实战训练与业务经营模拟，帮助优秀经纪人从 “业务骨干”到“团队引领者” 的静默生长与华丽转身，为公司持续发展储备兼具业务开拓力与团队领导力的未来门店管理者。',
                    image: require('@/assets/imgs/aboutUs/services_ql.jpg'),
                    icon: 'https://s1.ljcdn.com/parma/client/media/src/client/pages/about/home/imgs/dev_icon_02.d259c532.png'
                },
                {
                    name: '名盛管理学堂',
                    description: '引领变革，驱动增长。本线上学堂是专为管理层打造的 “战略指挥所”与“领导力孵化器”。旨在通过行业前沿的商业思维、系统的管理方法论和实战的团队赋能工具，助力管理者实现从“业务高手”到“团队领袖”、从“执行者”到“经营者”的跨越，从而提升门店业绩持续突破与增长',
                    image: require('@/assets/imgs/aboutUs/services_gl.jpg'),
                    icon: 'https://s1.ljcdn.com/parma/client/media/src/client/pages/about/home/imgs/dev_icon_03.e42c0cd0.png'
                }
            ],
        }
    },
    computed: {
        selectedService() {
            return this.services[this.selectedServiceIndex]
        }
    },
    mounted() {
        // 自动轮播
        this.startCarousel()

        // 添加滚动监听
        window.addEventListener('scroll', this.handleScroll)
    },
    beforeDestroy() {
        clearInterval(this.carouselInterval)
        window.removeEventListener('scroll', this.handleScroll)
    },
    methods: {
        toggleMobileMenu() {
            this.isMobileMenuOpen = !this.isMobileMenuOpen
        },

        closeMobileMenu() {
            this.isMobileMenuOpen = false
        },

        startCarousel() {
            this.carouselInterval = setInterval(() => {
                this.currentSlide = (this.currentSlide + 1) % this.carouselSlides.length
            }, 5000)
        },

        goToSlide(index) {
            this.currentSlide = index
            clearInterval(this.carouselInterval)
            this.startCarousel()
        },

        selectBusiness(index) {
            this.selectedBusiness = index
        },

        selectService(index) {
            this.selectedServiceIndex = index
        },

        handleScroll() {
            // 可以在这里添加滚动动画效果
            const elements = document.querySelectorAll('.animate-on-scroll')
            elements.forEach(el => {
                const rect = el.getBoundingClientRect()
                if (rect.top < window.innerHeight - 100) {
                    el.classList.add('animated')
                }
            })
        },
        goPage(path) {
            this.$router.push({
                path: path
            })
        }
    }
}
</script>

<style lang="less" scoped>
@import url('https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css');


.ke-home-page {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    color: #333;
    font-size: 16px;
    line-height: 1.5;
    min-height: 100vh;
}

/* 基础hover动画类 */
.hover-scale {
    transition: transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);

    &:hover {
        transform: scale(1.05);
    }
}

.hover-lift {
    transition: all 0.3s ease;

    &:hover {
        transform: translateY(-10px);
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
    }
}

.hover-pulse {
    transition: all 0.3s ease;
    position: relative;

    &:hover {
        animation: pulse 0.6s ease-in-out;
    }

    @keyframes pulse {
        0% {
            transform: scale(1);
        }

        50% {
            transform: scale(1.05);
        }

        100% {
            transform: scale(1);
        }
    }
}

.hover-glow {
    transition: all 0.3s ease;

    &:hover {
        box-shadow: 0 0 20px rgba(0, 123, 255, 0.3);
    }
}

.hover-zoom {
    transition: all 0.5s ease;

    &:hover {
        transform: scale(1.03);
        filter: brightness(1.1);
    }
}

.hover-rotate {
    transition: all 0.4s ease;

    &:hover {
        transform: rotateY(5deg) scale(1.02);
    }
}

.hover-bounce {
    transition: all 0.3s ease;

    &:hover {
        animation: bounce 0.5s ease;
    }

    @keyframes bounce {

        0%,
        20%,
        60%,
        100% {
            transform: translateY(0);
        }

        40% {
            transform: translateY(-10px);
        }

        80% {
            transform: translateY(-5px);
        }
    }
}

.hover-card {
    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);

    &:hover {
        transform: translateY(-10px);
        box-shadow: 0 15px 40px rgba(0, 0, 0, 0.1);

        .news-image img {
            transform: scale(1.1);
        }
    }
}

/* 轮播图 */
.carousel {
    position: relative;
    overflow: hidden;
    height: 600px;

    @media (max-width: 768px) {
        height: 400px;
    }

    .carousel-container {
        position: relative;
        width: 100%;
        height: 100%;
    }

    .carousel-slider {
        display: flex;
        width: 100%;
        height: 100%;
        transition: transform 0.5s ease-in-out;
    }

    .carousel-slide {
        flex: 0 0 100%;
        height: 100%;
    }

    .carousel-wrap {
        display: block;
        width: 100%;
        height: 100%;
        position: relative;
        text-decoration: none;
    }

    .carousel-image-wrapper {
        width: 100%;
        height: 100%;
        overflow: hidden;

        .img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.6s ease;
        }

        &:hover .img {
            transform: scale(1.05);
        }
    }

    .img-mask {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(to top, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 100%);
    }

    .text-wrap {
        position: absolute;
        bottom: 80px;
        left: 80px;
        color: white;
        max-width: 600px;

        @media (max-width: 768px) {
            bottom: 40px;
            left: 40px;
            right: 40px;
        }

        .title {
            font-size: 48px;
            font-weight: bold;
            margin-bottom: 30px;
            text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
            opacity: 0.9;

            @media (max-width: 768px) {
                font-size: 32px;
            }
        }
    }

    .more-btn {
        display: inline-flex;
        align-items: center;
        gap: 10px;
        padding: 12px 24px;
        background: rgba(255, 255, 255, 0.2);
        backdrop-filter: blur(10px);
        border-radius: 25px;
        color: white;
        font-size: 16px;
        cursor: pointer;
        transition: all 0.3s ease;
        border: 1px solid rgba(255, 255, 255, 0.3);

        &:hover {
            background: rgba(255, 255, 255, 0.3);
            transform: translateX(10px);
        }

        .icon {
            font-size: 14px;
            opacity: 0.8;
        }
    }

    .carousel-dots {
        position: absolute;
        bottom: 30px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        gap: 10px;
        list-style: none;
        margin: 0;
        padding: 0;

        li {
            button {
                width: 8px;
                height: 8px;
                border-radius: 50%;
                border: none;
                background: rgba(255, 255, 255, 0.5);
                cursor: pointer;
                transition: all 0.3s ease;
                padding: 0;

                &:hover {
                    background: rgba(255, 255, 255, 0.8);
                    transform: scale(1.2);
                }
            }

            &.active {
                button {
                    background: white;
                    transform: scale(1.2);
                }
            }
        }
    }
}

/* 最新动态 */
.article {
    padding: 80px 0;
    background: #f8f9fa;

    .wrap {
        max-width: 1200px;
        margin: 0 auto;
        padding: 0 20px;

        .title {
            font-size: 36px;
            font-weight: bold;
            text-align: center;
            margin-bottom: 50px;
            color: #333;
            position: relative;

            &::after {
                content: '';
                position: absolute;
                bottom: -10px;
                left: 50%;
                transform: translateX(-50%);
                width: 60px;
                height: 3px;
                background: linear-gradient(90deg, #007bff, #00bfff);
            }
        }
    }

    .news-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
        gap: 30px;
    }

    .news-card {
        background: white;
        border-radius: 12px;
        overflow: hidden;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);

        .news-image {
            height: 200px;
            overflow: hidden;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                transition: transform 0.6s ease;
            }
        }

        .news-content {
            padding: 24px;
        }

        .news-title {
            font-size: 20px;
            font-weight: bold;
            margin-bottom: 10px;
            color: #333;
        }

        .news-date {
            color: #666;
            font-size: 14px;
            margin-bottom: 15px;
        }

        .news-desc {
            color: #666;
            line-height: 1.6;
            margin-bottom: 20px;
        }

        .news-link {
            color: #007bff;
            text-decoration: none;
            font-weight: 500;
            transition: all 0.3s ease;

            &:hover {
                color: #0056b3;
                padding-left: 10px;
            }
        }
    }
}

/* 导航卡片 */
.nav {
    padding: 80px 0;

    .wrap {
        max-width: 1200px;
        margin: 0 auto;
        padding: 0 20px;

        .btns {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
            gap: 30px;
        }
    }

    .item {
        display: block;
        box-sizing: border-box;
        text-decoration: none;
        background: white;
        border-radius: 4px;
        overflow: hidden;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
        // padding: 30px;
        text-align: center;
        color: #333;
        position: relative;
        background-color: #000;
        border-color: #fff;
        cursor: pointer;

        >div:first-child {
            font-size: 24px;
            font-weight: bold;
            margin-bottom: 20px;
        }

        .title {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            width: 100%;
            font-family: PingFangSC-Semibold;
            font-weight: 700;
            font-size: 28px;
            color: #fff;
            letter-spacing: 0;
            text-align: center;
            z-index: 1;
        }

        .nav-image {
            // height: 200px;
            display: flex;
            align-items: center;
            justify-content: center;
            opacity: 0.7;
            border-color: #fff;

            img {
                border-color: #fff;
                max-width: 100%;
                max-height: 100%;
                transition: transform 0.4s ease;
                // -webkit-filter: grayscale(40%);
                // -moz-filter: grayscale(40%);
                // -ms-filter: grayscale(40%);
                // -o-filter: grayscale(40%);
                // filter: grayscale(40%);
                // filter: white;
                opacity: 0.8;
            }
        }

        &:hover {
            .nav-image img {
                transform: scale(1.1);
            }
        }
    }
}

/* 核心业务 */
.business {
    padding: 80px 0;
    background: #0a1428;

    .wrap {
        flex-wrap: nowrap;
        max-width: 1200px;
        margin: 0 auto;
        display: flex;

        .text {
            width: 400px;
            padding: 100px 50px 40px 0;
            transition: all .3s ease;

            .title {
                display: flex;
                position: relative;
                margin-bottom: 80px;
                white-space: nowrap;

                h3,
                h4 {
                    font-size: 28px;
                    color: #fff;
                    letter-spacing: 0;
                    line-height: 48px;
                }

                h3 {
                    font-weight: 700;
                    margin-right: 16px;
                }

                &::after {
                    content: "";
                    display: block;
                    width: 24px;
                    height: 2px;
                    border-radius: 2px;
                    background-color: #fff;
                    position: absolute;
                    bottom: -40px;
                    left: 0;
                    right: 0;
                }
            }

            .desc {
                font-family: PingFangSC-Regular;
                font-size: 16px;
                color: #fff;
                letter-spacing: 0;
                line-height: 28px;
                text-align: justify;
                min-height: 200px;
            }
        }
    }
}

.pic {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: stretch;
    width: 800px;
    line-height: 0;

    .item {
        width: 50%;
        overflow: hidden;
        position: relative;

        h3 {
            position: absolute;
            left: 40px;
            bottom: 36px;
            z-index: 1;
            font-family: PingFangSC-Semibold;
            font-weight: 700;
            font-size: 22px;
            color: #fff;
            letter-spacing: 0;
            line-height: 42px;
            text-shadow: 0 6px 32px rgba(0, 0, 0, .7);
        }

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            opacity: .6;
            transition: all .3s ease;
        }

        &:hover img {
            transform: scale(1.1);
            opacity: 1;
        }
    }
}

/* 服务者发展 */
.dev {
    padding: 80px 0;

    .wrap {
        max-width: 1200px;
        margin: 0 auto;
        padding: 0 20px;

        .title {
            font-size: 36px;
            font-weight: bold;
            text-align: left;
            margin-bottom: 50px;
            color: #333;
        }
    }

    .contain {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 50px;

        @media (max-width: 992px) {
            grid-template-columns: 1fr;
        }
    }

    .img {
        position: relative;
        width: 791px;
        height: 560px;
        margin-right: 24px;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: 50%;
        text-indent: -9999px;

        &::after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: linear-gradient(to top, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 100%);
        }

        >span {
            position: relative;
            z-index: 1;
        }
    }

    .list {
        display: flex;
        flex-direction: column;
        width: 385px;
        transition: all .3s ease;
    }

    .service-item {
        position: relative;
        background: #fff;
        box-shadow: 0 4px 30px 0 rgba(0, 0, 0, .05);
        margin-bottom: 24px;
        padding: 32px 40px;
        min-width: 300px;

        .name {
            font-family: PingFangSC-Semibold;
            font-weight: 700;
            font-size: 20px;
            color: #555;
            line-height: 24px;
            letter-spacing: 0;
            margin-bottom: 0;
        }

        .name.select {
            margin-bottom: 16px;
            font-size: 22px;
            color: #000;
        }

        .desc {
            font-family: PingFangSC-Regular;
            font-size: 16px;
            color: #555;
            letter-spacing: 0;
            line-height: 28px;
            height: 232px;
            text-align: justify;
            display: none;
        }

        .desc.select {
            display: block;
        }

        .icon {
            position: absolute;
            width: 64px;
            height: 60px;
            top: 0;
            bottom: 0;
            right: 32px;
            margin: auto 0;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            display: block;
        }

        .icon.select {
            display: block;
        }
    }

    &:hover {
        .service-image img {
            transform: scale(1.1);
        }
    }

    &.select {
        background: linear-gradient(135deg, #f8f9fa, #e9ecef);
    }
}


/* 响应式设计 */
@media (max-width: 768px) {}

@media (max-width: 576px) {
    .carousel {
        .text-wrap {
            .title {
                font-size: 24px;
            }
        }

        .more-btn {
            padding: 10px 20px;
            font-size: 14px;
        }
    }

    .dev {
        .wrap {
            .title {
                font-size: 28px;
            }
        }
    }
}
</style>